import React, { useState } from "react";
import { TextField, Button } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"; // or @mui/x-date-pickers/AdapterMoment
import { DatePicker } from "@mui/x-date-pickers";
import { SemanticColor } from "node-library/dist/colors";
import { AlertIcon } from "./svgIcons";

interface Props {
	selectedDate: Date | null;
	setSelectedDate: React.Dispatch<React.SetStateAction<Date | null>>;
	errorMsg?: string;
	disabled?: boolean;
}

function CustomDateTimePicker(props: Props) {
	const { selectedDate, setSelectedDate } = props;

	const handleDateChange = (newDate: Date | null) => {
		setSelectedDate(newDate);
	};

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<div>
				<DateTimePicker
					slotProps={{ field: { clearable: true } }}
					disabled={props.disabled}
					value={selectedDate}
					onChange={handleDateChange}
				/>
				{props.errorMsg && props.errorMsg.length > 0 && (
					<div
						style={{
							display: "flex",
							gap: "5px",
							color: SemanticColor.ERROR,
							alignItems: "center",
						}}
					>
						<AlertIcon></AlertIcon>
						{props.errorMsg}
					</div>
				)}
			</div>
		</LocalizationProvider>
	);
}

function CustomDatePicker(props: Props) {
	const { selectedDate, setSelectedDate } = props;

	const handleDateChange = (newDate: Date | null) => {
		setSelectedDate(newDate);
	};

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<div>
				<DatePicker
					disabled={props.disabled}
					value={selectedDate}
					onChange={handleDateChange}
					slotProps={{ field: { clearable: true } }}
				/>
				{props.errorMsg && props.errorMsg.length > 0 && (
					<div
						style={{
							display: "flex",
							gap: "5px",
							color: SemanticColor.ERROR,
							alignItems: "center",
						}}
					>
						<AlertIcon></AlertIcon>
						{props.errorMsg}
					</div>
				)}
			</div>
		</LocalizationProvider>
	);
}

export { CustomDateTimePicker, CustomDatePicker };
